module.exports = __webpack_public_path__ + "static/media/distrigo_logo.a5a9fabe.svg";